// extracted by mini-css-extract-plugin
export default {"root":"ShareTextPreview_root__8sjGw","line":"ShareTextPreview_line__4lnLD"};